(function(){
  var root=document.querySelector('[data-hcu-pdp]'); if(!root) return;
  var $=function(s,r){return (r||root).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||root).querySelectorAll(s))};
  var product; try{product=JSON.parse($('[data-hcu-product]').textContent)}catch(e){return}
  var vid=$('[data-hcu-vid]'), addBtn=$('[data-hcu-addbtn]'), buyNow=$('[data-hcu-buynow]'), form=document.getElementById('hcu-buyform');
  var mainImg=$('.hcu-gal__img'), zoom=$('[data-hcu-zoom]');
  var sticky=document.querySelector('[data-hcu-sticky]'), stickyAdd=document.querySelector('[data-hcu-sticky-add]'), stickyPrice=document.querySelector('[data-hcu-price-sticky]');

  function money(c){return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')}
  function priceHTML(c){var s=(c/100).toFixed(2).split('.');return '<sup>$</sup>'+Number(s[0]).toLocaleString('en-US')+'<sup>'+s[1]+'</sup>'}


  /* remember for "recently viewed" */
  try{var img=product.featured_image?(product.featured_image.indexOf('//')===0?'https:'+product.featured_image:product.featured_image):'';
    var rec=JSON.parse(localStorage.getItem('hcu_recent')||'[]').filter(function(x){return x.h!==product.handle});
    rec.unshift({h:product.handle,t:product.title,v:product.vendor,p:product.price,i:img?img+(img.indexOf('?')>-1?'&':'?')+'width=400':''});
    localStorage.setItem('hcu_recent',JSON.stringify(rec.slice(0,12)));}catch(e){}
  /* gallery */
  function showMedia(src,id){
    if(!mainImg||!src) return;
    mainImg.removeAttribute('srcset'); mainImg.src=src;
    if(zoom) zoom.href=src.replace(/width=\d+/,'width=2000');
    $$('.hcu-gal__th').forEach(function(t){t.classList.toggle('is-on',String(t.dataset.media)===String(id))});
  }
  $$('.hcu-gal__th').forEach(function(t){
    t.addEventListener('click',function(){showMedia(t.dataset.src,t.dataset.media)});
    t.addEventListener('mouseenter',function(){showMedia(t.dataset.src,t.dataset.media)});
  });

  /* variants */
  function current(){
    var opts=[]; $$('[data-hcu-opt]').forEach(function(i){if(i.checked)opts[+i.dataset.hcuOpt]=i.value});
    return product.variants.find(function(v){return v.options.every(function(o,i){return opts[i]===undefined||o===opts[i]})});
  }
  function markAvailability(){
    var groups={}; $$('[data-hcu-opt]').forEach(function(i){(groups[i.dataset.hcuOpt]=groups[i.dataset.hcuOpt]||[]).push(i)});
    var sel=[]; $$('[data-hcu-opt]').forEach(function(i){if(i.checked)sel[+i.dataset.hcuOpt]=i.value});
    Object.keys(groups).forEach(function(g){
      groups[g].forEach(function(i){
        var test=sel.slice(); test[+g]=i.value;
        var ok=product.variants.some(function(v){return v.available&&v.options.every(function(o,k){return test[k]===undefined||o===test[k]})});
        i.parentNode.classList.toggle('is-na',!ok);
      });
    });
  }
  function update(){
    var v=current();
    $$('[data-hcu-opt]').forEach(function(i){if(i.checked){var l=$('[data-hcu-optlabel="'+i.dataset.hcuOpt+'"]');if(l)l.textContent=i.value}});
    markAvailability();
    var ok=!!(v&&v.available);
    if(v){
      vid.value=v.id;
      $$('[data-hcu-price]').forEach(function(p){p.innerHTML=priceHTML(v.price)});
      if(stickyPrice) stickyPrice.textContent=money(v.price);
      var save=$('[data-hcu-save]'),was=$('[data-hcu-was]');
      if(v.compare_at_price&&v.compare_at_price>v.price){save.hidden=false;save.textContent='-'+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%';was.hidden=false;was.querySelector('s').textContent=money(v.compare_at_price)}else{save.hidden=true;was.hidden=true}
      if(v.featured_media) showMedia(v.featured_media.preview_image.src+(v.featured_media.preview_image.src.indexOf('?')>-1?'&':'?')+'width=900',v.featured_media.id);
      var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u.toString());
    }
    $('[data-hcu-stock]').innerHTML=!v?'<span class="is-out">This combination is not available</span>':(ok?'<span class="is-in">In stock</span>':'<span class="is-out">Currently unavailable</span>');
    addBtn.disabled=!ok; addBtn.textContent=ok?'Add to cart':(v?'Sold out':'Unavailable');
    buyNow.disabled=!ok; if(stickyAdd) stickyAdd.disabled=!ok;
  }
  $$('[data-hcu-opt]').forEach(function(i){i.addEventListener('change',update)});
  if($$('[data-hcu-opt]').length) markAvailability();

  /* add to cart */
  var toast=document.querySelector('[data-hcu-toast]'),tt;
  function showToast(h){if(!toast)return;toast.innerHTML=h;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('is-on')},4500)}
  function add(then){
    addBtn.disabled=true; var old=addBtn.textContent; addBtn.textContent='Adding...';
    return fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(item){
        if(then==='checkout'){location.href='/checkout';return}
        return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
          document.querySelectorAll('[data-hcu-count]').forEach(function(n){n.textContent=c.item_count});
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          showToast('<b>Added to cart</b><br>'+item.product_title+(item.variant_title?' ('+item.variant_title+')':'')+'<br><a href="/cart">View cart and check out</a>');
        });
      })
      .catch(function(e){showToast('<b>Could not add this item.</b><br>'+((e&&e.description)||'Please try again or call us.'))})
      .then(function(){addBtn.disabled=false;addBtn.textContent=old});
  }
  form.addEventListener('submit',function(e){if(!window.fetch)return;e.preventDefault();add()});
  buyNow.addEventListener('click',function(){add('checkout')});
  if(stickyAdd) stickyAdd.addEventListener('click',function(){add()});

  /* sticky bar on phones once the buy box scrolls away */
  if(sticky&&'IntersectionObserver' in window&&window.matchMedia('(max-width: 900px)').matches){
    new IntersectionObserver(function(en){sticky.hidden=en[0].isIntersecting||en[0].boundingClientRect.top>0}).observe(addBtn);
  }

  /* recommendations */
  var recs=$('[data-hcu-recs]');
  if(recs&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){if(!en[0].isIntersecting)return;io.disconnect();
      fetch(recs.dataset.url).then(function(r){return r.text()}).then(function(t){var d=document.createElement('div');d.innerHTML=t;var s=d.querySelector('.shopify-section')||d;recs.innerHTML=s.innerHTML;});
    },{rootMargin:'400px'}); io.observe(recs);
  }
})();
